export default "__VITE_ASSET__b7Q9xamQ__"